import styled, {keyframes} from 'styled-components'
import IconArrow from '../../../assets/svg/comp-button.svg'


const slidePipe = keyframes`
    0% {
        transform: translateX(0%);
        opacity: 0;
    }
    10% {
        opacity: 1;
    }
    90% {
        opacity: 1;
    }
    100% {
        transform: translateX(204%);
        opacity: 0;
    }
`;

export const WebdoorHome = {
    Container: styled.section`
        overflow: visible;
        max-width: 1560px;
        display: flex;
        gap: 35px;
        flex-direction: column-reverse;
        margin: 87px auto 37px;
        position: relative;
        padding: 0px 23px 35px;
    
        ::after {
            z-index: 0;
            content: "";
            width: 100%;
            height: 50%;
            bottom: 0;
            left: 0;
            position: absolute;
            border-radius: 0 0 24px 24px;
            background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #F0F0F0 100%);
        }
    
        .react-multi-carousel {
            &-list {
                overflow: visible;
                position: relative;
                max-width: 1420px;
                z-index: 5;
            }
    
            &-dot-list {
                counter-reset: item;
                bottom: -76px;
    
                button {
                    counter-increment: item;
                    font-family: 'Shell Book';
                    background: transparent;
                    appearance: none;
                    border: none;
                    color: #3B3B3B;
                    font-size: 16px;
                    height: 40px;
                        
                    ::before {
                        font-family: 'Shell Heavy';
                        content: "0" counter(item);
                    }
    
                    &.inactive {
                        .label {
                            display: none;
                        }
                    }
    
                    &.active {
                        display: flex;
                        align-items: center;
                        
                        @media (min-width: 768px) {
                            order: -1;
                            width: 100%;
                            max-width: 410px;                            
                            position: relative;
                            padding-right: 160px;

                            ::before {
                                content: "0" counter(item) " - ";
                                width: 40px;
                            }

                            .label {
                                text-align: left;
                                display: block;
                                width: 100%;
    
                                ::after {
                                    right: 0;
                                }
                            }

                            .timeline-line {
                                position: absolute;
                                top: 60%;
                                display: block;
                                margin-top: -.5px;
                                right: 20px;
                                height: 1px;
                                width: 122px;
                                background-color: #3B3B3B;
                            }
                            
                            .timeline-pipe {
                                margin-top: -1.5px;
                                display: block;
                                height: 4px;
                                width: 40px;
                                right: 102px;
                                border-radius: 4px;
                                background-color: #DD1D21;
                                animation: ${slidePipe} 5s linear forwards;
                            }
                        }
                        
                        @media (min-width: 1024px) {
                            max-width: 600px;
                        }
    
                    }
                }
            }
            
            @media (max-width: 1365px) {
                &-dot-list {
                    button {
                        font-size: 12px;
                    }
                }
            }
        }

        .react-multiple-carousel__arrow {
            &--left,
            &--right {
                background: url(${IconArrow}) no-repeat;
                background-size: contain;
                border-radius: 0;
                bottom: -80px;
                height: 48px;
                width: 48px;

                ::before {
                    display: none;
                }
            }

            &--left {
                left: initial;
                right: 0px;
                transform: rotate(180deg) scale(1);

                &:hover {
                    transform: rotate(180deg) scale(1.2);
                }
            }
            
            &--right {
                transform: scale(1);
                right: -65px;

                &:hover {
                    transform: scale(1.2);
                }
            }
        }

        @media (max-width: 1599px) {
            .react-multiple-carousel__arrow {
                &--left {
                    right: 60px;
                }
                
                &--right {
                    right: 0;
                }
            }
        }

        @media (max-width: 1365px) {
            .react-multi-carousel {    
                &-dot-list {        
                    button {
                        .label {
                            ::before {
                                width: 80px;
                                right: 10px;
                            }
                            
                            ::after {
                                width: 28px;
                                right: 62px;
                            }
                        }
                    }
                }            
            }
        }

        @media (max-width: 1023px) {
            padding: 0px 20px 35px;
            margin-left: 12px;
            margin-right: 12px;
            
            .react-multi-carousel {

                &-list {
                    max-width: 724px;
                }
            }

            .react-multiple-carousel__arrow {
                &--left,
                &--right {
                    bottom: -80px;
                    height: 44px;
                    width: 44px;

                    ::before {
                        display: none;
                    }
                }

                &--left {
                    right: 50px;
                }
                
                &--right {
                    right: 0px;
                }
            }
        }

        .react-multi-carousel {    
            &-item {
                visibility: hidden;
                opacity: 0;
                transform: scale(0);
                transition: all .8s;
                
                &.react-multi-carousel-item--active {
                    &,
                    & + .react-multi-carousel-item {
                        transform: scale(1);
                        transition: all 0s;
                        visibility: visible;
                        opacity: 1;
                    }
                }
            }
        }

        @media (max-width: 767px) {
            padding: 0px 10px 35px;
            margin-left: 0px;
            margin-right: 0px;
            
            .react-multi-carousel {    
                &-item {
                    padding-left: 6px;
                    padding-right: 6px;
                }

                &-dot-list {        
                    button {                        
                        &.active {
                            .label {
                                display: none;
                            }

                            color: #DD1D21; 
                        }
                    }
                }
            }
        }
    `,
    
    Item: styled.article`
        overflow: hidden;
        border-radius: 24px;
        display: block;
        
        @media (min-width: 768px) {
            margin-right: 20px;
        }
    `,

    Label: styled.h2`
        font-family: 'Shell Heavy';
        text-transform: uppercase;
        position: relative;
        left: 38px;
        z-index: 5;
        font-size: 18px;
        font-weight: 600;
        line-height: 160%;
        color: #3B3B3B;
        margin: 5px 0 0;
        
        @media (max-width: 1024px) {
            font-size: 12px;
            left: 0px;
            max-width: 90px;
        }
    `,

    Image: styled.img`
        width: 100%;
        display: block;
        max-width: 100%;
    `,

    Link: styled.a`
        display: block;
    `
}